import React, { useEffect } from 'react';
import swal from 'sweetalert';
import Header from '../../component/Header';
import { onFinishedWebView } from '../../helper/mobile';

const InstantConsult = () => {
  
    useEffect(() => {
        swal({
            closeOnClickOutside: false,
            className: "swal-height-width-change",
            title: "we are currently away",
            text: "oops... You caught us at a bad time, we will be back soon!",
            buttons: "Okay"
        }).then(() => {
            onFinishedWebView(); 
        });
    }, []);
    
    return (
        <div>
          <Header title="Instant consult" isBookingNavDisplay={true} />
        </div>
    );
};

export default InstantConsult;